import React from 'react';

export type CardshellRowProps = {
  /**  children (text/jsx) to be rendered in component  */
  children: React.ReactNode,
};

export const CardshellRow = ({
  children,
  ...props
}: CardshellRowProps & React.HTMLAttributes<HTMLElement>) => {

  // HOOKS ##############################################################

  // RENDER ##############################################################
  const propsClassNames = props.className || '';
  delete props.className;

  return (
      <div
        className={`row flex-wrap flex-items-stretch pad-b-xs pad-t-xs ${propsClassNames}`}
        {...props}
      >
        {children}
      </div>
  );
}